export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' }
];

// Re-export set types utilities for convenience
// All set type values must be dynamically fetched from the product_masters table.
export { getSetTypes, getSetTypeValues, getSetTypeLabels, isValidSetType, getSetTypeLabel, getSetTypeValue, useSetTypes } from '../../../../config/setTypes';
export type { SetTypeOption } from '../../../../config/setTypes';

export const PANEL_COUNT_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

// Re-export item types utilities for convenience
export { getItemTypes, getItemTypeValues, getItemTypeLabels, isValidItemType, getItemTypeLabel, getItemTypeValue, useItemTypes } from '../../../../config/itemTypes';
export type { ItemTypeOption } from '../../../../config/itemTypes';

// Status constants with integer values
export const ORDER_STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  DISPATCHED: 3
} as const;

export const PRODUCT_STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  DISPATCHED: 3
} as const;

export const ITEM_STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2
} as const;

export const STAGE_STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2
} as const;

// Status labels for display
export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: 'Pending',
  [ORDER_STATUS.IN_PROGRESS]: 'In Progress',
  [ORDER_STATUS.COMPLETED]: 'Completed',
  [ORDER_STATUS.DISPATCHED]: 'Dispatched'
} as const;

export const PRODUCT_STATUS_LABELS = {
  [PRODUCT_STATUS.PENDING]: 'Pending',
  [PRODUCT_STATUS.IN_PROGRESS]: 'In Progress',
  [PRODUCT_STATUS.COMPLETED]: 'Completed',
  [PRODUCT_STATUS.DISPATCHED]: 'Dispatched'
} as const;

export const ITEM_STATUS_LABELS = {
  [ITEM_STATUS.PENDING]: 'Pending',
  [ITEM_STATUS.IN_PROGRESS]: 'In Progress',
  [ITEM_STATUS.COMPLETED]: 'Completed'
} as const;

export const STAGE_STATUS_LABELS = {
  [STAGE_STATUS.PENDING]: 'Pending',
  [STAGE_STATUS.IN_PROGRESS]: 'In Progress',
  [STAGE_STATUS.COMPLETED]: 'Completed'
} as const;
